(function () {
  'use strict';

  const { subEvents, PUB_SUB_EVENTS, fetchConfig } = window.Universe;

  class ProductForms {
    constructor() {
      this.init();
    }

    setup() {
      for (let i = 0; i < this.DOM.forms.length; i++) {
        this.instances.push(new ProductForm(this.DOM.forms[i]));
      }
    }

    destroy() {
      if (this.DOM) {
        for (let i = 0; i < this.instances.length; i++) {
          this.instances[i].destroy();
        }
        this.instances = [];
        this.DOM = undefined;
      }
    }

    reinit() {
      this.destroy();
      this.init();
    }

    init(container = document) {
      const forms = container.querySelectorAll('.js-product-form');

      if (forms.length) {
        this.DOM = {};
        this.DOM.forms = forms;
        this.instances = [];

        this.setup();
      }
    }
  }

  class ProductForm {
    constructor(form) {
      this.init(form);
    }

    setup() {
      this._onSubmit = (event) => { this.onSubmit(event); };
      this.DOM.form.addEventListener('submit', this._onSubmit);
    }

    onSubmit(event) {
      event.preventDefault();

      if (this.DOM.submit.getAttribute('aria-disabled') === 'true') return;
      if (this.DOM.submit.classList.contains('is-loading')) return;

      this.DOM.submits.forEach((btn) => btn.classList.add('is-loading'));

      const submitsArray = Array.from(this.DOM.submits);
      this._submitter = event.submitter && !submitsArray.includes(event.submitter)
        ? event.submitter
        : null;
      if (this._submitter) this._submitter.classList.add('is-loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.DOM.form);
      config.body = formData;

      fetch(window.routes.cart_add_url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.log('product-form-' + formData.get('id') + ' errors:', response.errors || response.description);

            if (!this.DOM.errorMessage) return;

            this.DOM.errorMessage.classList.toggle('is-visible', response.description);

            let errorText = '';
            if (typeof response.description == 'object') {
              for (const error in response.description) {
                if (errorText.length > 0) {
                  errorText = errorText + ', ' + response.description[error];
                } else {
                  errorText = response.description[error];
                }
              }
            } else {
              errorText = response.description;
            }

            this.DOM.errorMessage.innerText = errorText;
            const yOffset = -200;
            const y = this.DOM.errorMessage.getBoundingClientRect().top + window.scrollY + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });

            return;
          } else {
            if (window.theme && window.theme.cart_type === 'page') {
              window.location.href = window.routes.cart_url;
              return;
            }
            subEvents.publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          }
        })
        .catch((e) => {
          console.error('error', e);
        })
        .finally(() => {
          if (this.DOM?.submits) this.DOM.submits.forEach((btn) => btn.classList.remove('is-loading'));
          if (this._submitter) {
            this._submitter.classList.remove('is-loading');
            this._submitter = null;
          }
        });
    }

    destroy() {
      if (this.DOM) {
        this.DOM.form.removeEventListener('submit', this._onSubmit);
        this.DOM = undefined;
      }
    }

    init(form) {
      if (form) {
        this.DOM = {};
        this.DOM.form = form;
        this.DOM.submit = this.DOM.form.querySelector('.js-product-form-submit');
        this.DOM.submits = this.DOM.form.querySelectorAll('.js-product-form-submit');
        this.DOM.errorMessage = this.DOM.form.querySelector('.js-product-form-error');

        this.setup();
      }
    }
  }

  window.Universe = window.Universe || {};
  window.Universe.ProductForms = ProductForms;
  window.Universe.ProductForm = ProductForm;
})();
